import types from '../types/mutation-types';

export default {
  [types.SET_USER](state, user) {
    state.user = user;
  },
};
